const enUS = {
  common: {
    acontecer: '(TO MAKE)',
    falamos: 'LET\'S TALK?',
    quemSomos: 'WHO WE ARE?',
    workWithUs: 'WORK WITH US',
    vagas: 'WORK WITH US',
    back: 'BACK',
    instagram: 'INSTAGRAM',
    linkedin: 'LINKEDIN',
    copyright: 'FAZ ALL RIGHTS RESERVED'
  },
  sound: {
    on: 'ON',
    off: 'OFF'
  },
  navigation: {
    home: 'Home',
    about: 'About',
    contact: 'Contact'
  },
  footer: {
    title: 'LET\'S <span class="italic font-cormorant">make it</span> HAPPEN?',
    subtitle: 'Let\'s make it happen?'
  },
  home: {
    hero: {
      title: 'WE ARE CRAFT : WE MAKE IT HAPPEN.',
      subtitle: 'We are a boutique creative agency with an international vision and detail-oriented craft.',
      description: [
        'We are a boutique creative agency with an international vision and detail-oriented craft.',
        'We believe excellence builds trust, stands the test of time, and turns brands into icons.',
        'We pair big ideas with precise execution.',
        'We listen carefully, build intentionally, and deliver rigorously.',
        'We work as one and elevate culture.',
        'More than an agency, we are creative partners.'
      ]
    },
    services: {
      title: 'WHAT WE DO',
      items: {
        branding: {
          title: 'BRANDING AND REBRANDING',
          description: 'We create and revitalize brands with strategy, clarity, and identity. From naming to visual identity — voice to positioning — we build brands with character and purpose.'
        },
        identidade: {
          title: 'BRAND IDENTITY AND COMMUNICATION',
          description: 'We define and align positioning, archetype, tone of voice, and culture. We communicate with consistency, personality, and intent — on and offline.'
        },
        campanhas: {
          title: 'CREATIVE DIRECTION AND CAMPAIGNS',
          description: 'We develop campaigns, online and offline, with strong concepts, refined execution, and real impact. From idea to production, we deliver with craft and consistency.'
        },
        conteudo: {
          title: 'BRAND CONTENT',
          description: 'We craft visual and verbal narratives focused on lifestyle, emotion, and aspiration. We produce content that expresses essence, ambition, and aesthetic.'
        },
        digital: {
          title: 'PREMIUM DIGITAL EXPERIENCE',
          subtitle: '(WEB & PRODUCT)',
          description: 'We design digital solutions with strategic focus, UX/UI expertise, and a contemporary aesthetic. We create websites, platforms, and digital products with attention to detail and visual impact.'
        },
        consultoria: {
          title: 'CREATIVE AND CULTURAL CONSULTING',
          description: 'We support brands in transition or growth with strategic thinking and cultural sensitivity. We identify the path to relevance — now and into the future.'
        }
      }
    },
    modoOperandi: {
      title: 'Modus Operandi',
      subtitle: 'HOW WE DO IT',
      items: {
        envolvimento: {
          title: 'WITH INVOLVEMENT',
          description: 'Our team is hands-on, with senior direction and AI collaboration.'
        },
        proximidade: {
          title: 'WITH PROXIMITY',
          description: 'We build direct relationships — no fluff.'
        },
        foco: {
          title: 'WITH FOCUS',
          description: 'We work with intent — diving deep.'
        },
        agilidade: {
          title: 'WITH AGILITY',
          description: 'We align through clear sprints and deliver flexibly.'
        },
        parceria: {
          title: 'WITH PARTNERSHIP',
          description: 'More than vendors, we are co-creators.'
        },
        cultura: {
          title: 'WITH CULTURE',
          description: 'We honor identity and elevate narratives.'
        }
      }
    }
  },
  about: {
    title: 'WE DON\'T BEAT AROUND THE BUSH.',
    subtitle: 'A SIMPLE NAME, A CLEAR MISSION, A LEGACY OF DOING.',
    description: [
      'Do with intention; in detail, in aesthetics and in creative courage.',
      'In the right measure; proximity in process, impact at global scale.',
      'FAZ was born from VX, a group with over 20 years of experience between Brazil and Europe.',
      'We carry in our DNA the legacy of an agency with internationally recognized campaigns',
      'and a contemporary vision, tuned to each context.',
      'We combine culture with craft, with distinct paths and a common vision.'
    ]
  },
  contact: {
    form: {
      name: 'NAME',
      email: 'EMAIL',
      subject: 'SUBJECT',
      message: 'MESSAGE',
      submit: 'SEND',
      sending: 'SENDING...',
      sendAnother: 'Send another message',
      tryAgain: 'Try again',
      orSendMessage: 'OR SEND US A MESSAGE:',
      placeholders: {
        name: 'Enter full name',
        email: 'Enter email',
        subject: 'Enter message subject',
        message: 'Enter message'
      }
    },
    messages: {
      success: {
        title: 'Message sent successfully!',
        subtitle: 'We will contact you soon.'
      },
      error: {
        title: 'Error sending message!',
        subtitle: 'Please try again in a few moments.'
      }
    },
    validation: {
      name: {
        required: 'Name is required',
        minLength: 'Name must have at least 2 characters',
        maxLength: 'Name must have maximum 50 characters'
      },
      email: {
        required: 'Email is required',
        invalid: 'Email must have a valid format'
      },
      subject: {
        required: 'Subject is required',
        minLength: 'Subject must have at least 5 characters',
        maxLength: 'Subject must have maximum 100 characters'
      },
      message: {
        required: 'Message is required',
        minLength: 'Message must have at least 10 characters',
        maxLength: 'Message must have maximum 1000 characters'
      },
      turnstile: {
        required: 'Please complete the security verification',
        error: 'Security verification failed. Please try again.',
        expired: 'Security verification expired. Please verify again.'
      }
    },
    phone: {
      title: 'CALL US:',
      number: '+351 923 522 385'
    }
  },
  marquee: {
    light: {
      brand: 'WE ARE FAZ',
      tagline: 'Somos Faz'
    },
    dark: {
      entrega: 'DELIVERY',
      evolucao: 'EVOLUTION',
      estrategia: 'STRATEGY',
      expressao: 'EXPRESSION'
    }
  },
  workWithUs: {
    title: 'WORK WITH US',
    subtitle: 'Join our creative team and help us make it happen.',
    description: [
      'We are looking for creative talents who share our passion for excellence and attention to detail.',
      'We offer an inspiring work environment with international projects and growth opportunities.',
      'If you have a thirst for challenges and want to be part of a team that values creativity and innovation, come work with us.',
      'Send your portfolio and CV to careers@wearefaz.com and let\'s make it happen together.'
    ],
    whyWorkWithUs: {
      title: 'WHY WORK WITH US?',
      items: [
        {
          title: 'CREATIVE FREEDOM',
          description: 'We believe in giving our team the space to explore, experiment, and create without boundaries.'
        },
        {
          title: 'INTERNATIONAL EXPOSURE',
          description: 'Work on projects that span across different cultures and markets, expanding your creative horizons.'
        },
        {
          title: 'CRAFT EXCELLENCE',
          description: 'Be part of a team that values attention to detail and delivers work of the highest quality.'
        },
        {
          title: 'GROWTH OPPORTUNITIES',
          description: 'We invest in our team\'s development with continuous learning and career advancement opportunities.'
        }
      ]
    },
    openPositions: {
      title: 'OPEN POSITIONS',
      applyButton: 'Apply Now',
      items: [
        {
          title: 'SENIOR CREATIVE DIRECTOR',
          location: 'Lisbon / Remote',
          type: 'Full-time',
          postedDate: 'Posted 2 days ago',
          description: 'Lead creative direction for international brands and mentor our creative team.',
          skills: ['Creative Direction', 'Brand Strategy', 'Team Leadership', 'Adobe Creative Suite']
        },
        {
          title: 'DIGITAL DESIGNER',
          location: 'Lisbon',
          type: 'Full-time',
          postedDate: 'Posted 1 week ago',
          description: 'Create stunning digital experiences and user interfaces for our premium clients.',
          skills: ['UI/UX Design', 'Figma', 'Web Design', 'Prototyping']
        },
        {
          title: 'COPYWRITER',
          location: 'Remote',
          type: 'Part-time',
          postedDate: 'Posted 3 days ago',
          description: 'Craft compelling copy that brings brands to life across all touchpoints.',
          skills: ['Copywriting', 'Brand Voice', 'Content Strategy', 'English/Portuguese']
        }
      ]
    },
    howToApply: {
      title: 'HOW TO APPLY',
      description: 'Ready to join our team? Here\'s how to get started:',
      steps: [
        'Send your portfolio and CV to careers@wearefaz.com',
        'Include a cover letter explaining why you want to work with us',
        'We\'ll review your application and get back to you within 5 business days',
        'If selected, we\'ll schedule a creative interview to discuss your work',
        'Join our team and start making it happen!'
      ]
    }
  },
  workWithUsPage: {
    firstSection: {
      title: 'PEOPLE WHO MAKE IT HAPPEN.',
      subtitle: 'Curiosity, Creativity. Courage.',
      description: [
        'For those who challenge ideas, craft with intention and shake the status quo.',
        'Check our openings and reach out even if there\'s no perfect match.',
        'Great talent can\'t always wait.'
      ],
      letsTalkButton: 'LET\'S TALK'
    },
    jobs: {
      learnMoreButton: 'LEARN MORE',
      accountManager: {
        location: 'LISBOA',
        title: 'ACCOUNT MANAGER'
      },
      seniorDesigner: {
        location: 'LISBOA',
        title: 'SENIOR MULTIDISCIPLINARY DESIGNER'
      },
      personalAssistant: {
        location: 'LISBOA',
        title: 'PERSONAL ASSISTANT / JUNIOR CHIEF OF STAFF'
      }
    },
    accountManager: {
      title: 'ACCOUNT MANAGER (FOUNDING TEAM)',
      location: 'LISBOA',
      introduction: [
        'FAZ is looking for an organized, proactive Account Manager with strong leadership skills.',
        'You will be the main point of contact between clients and the creative team, ensuring excellent account management, high-quality project delivery, and the establishment of processes from the ground up.'
      ],
      whatWeExpect: {
        title: 'WHAT WE EXPECT FROM AN ACCOUNT MANAGER',
        items: [
          'Lead client accounts and relationships strategically and hands-on.',
          'Translate business objectives into actionable roadmaps and KPIs.',
          'Build processes, templates, and playbooks to ensure team efficiency.',
          'Communicate clearly, elegantly, and effectively with clients and internal teams.'
        ]
      },
      responsibilities: {
        title: 'RESPONSIBILITIES',
        items: [
          'Manage the full account cycle: briefing → planning → execution → reporting.',
          'Coordinate internal and external teams (creative, content, paid media, web).',
          'Ensure quality, deadlines, and budget control.',
          'Prepare proposals, SOWs, timelines, and post-sale activities (upsell/cross-sell).',
          'Monitor metrics and turn data into strategic decisions.'
        ]
      },
      qualifications: {
        title: 'QUALIFICATIONS',
        items: [
          'Agency experience (account/project) with a 360º marketing perspective.',
          'Fluent in English.',
          'Strategic mindset with impeccable execution and strong ownership.',
          'Comfortable with digital tools: Google Workspace, Slack, Notion/Monday/Asana, HubSpot/CRM.',
          'Ability to turn social, paid, and web metrics into actionable insights.'
        ]
      },
      whatWeOffer: {
        title: 'WHAT WE OFFER',
        items: [
          'Integration into the Founding Team of a boutique agency with global ambition.',
          'Real autonomy and direct contact with leadership, with a clear growth path.',
          'Remote work in 2025, with an office in Lisbon starting in 2026.',
          'Culture of craft, strategic creativity, and a "get things done" mindset.',
          'Competitive compensation, tailored to experience and performance growth.'
        ]
      },
      locationArrangement: {
        title: 'LOCATION & ARRANGEMENT',
        items: [
          'Remote (Portugal), with occasional availability for in-person meetings or travel.',
          'Schedule compatible with international clients.'
        ]
      },
      first90Days: {
        title: 'FIRST 90 DAYS — WHAT WE EXPECT TO SEE',
        items: [
          'Completed onboarding and foundational processes set up (rituals, templates, dashboards).',
          '2–3 active accounts with high NPS/CSAT, controlled deadlines, and monthly reporting.',
          'Communication playbook with clients and responsibility matrix established.'
        ]
      },
            howToApply: {
              title: 'HOW TO APPLY',
              text: 'Send your CV (PDF) to',
              email: 'hello@wearefaz.com',
              subject: 'with the subject: "Account Manager — FAZ".'
            },
      applyButton: 'APPLY NOW'
    },
    seniorDesigner: {
      title: 'SENIOR MULTIDISCIPLINARY DESIGNER',
      location: 'LISBOA',
      introduction: [
        'FAZ is looking for a creative, strategic, and autonomous Senior Multidisciplinary Designer.',
        'You will be the main point of contact between clients and the creative team, responsible for developing high-quality visual and digital solutions, ensuring project excellence, and establishing processes from the ground up.'
      ],
      whatWeExpect: {
        title: 'WHAT WE EXPECT FROM A SENIOR MULTIDISCIPLINARY DESIGNER',
        items: [
          'Develop multidisciplinary design projects with attention to detail and visual consistency.',
          'Translate business objectives into impactful visual and digital experiences (websites, apps, campaigns, digital content).',
          'Apply strong design principles to create clear, functional, and aesthetically compelling concepts.',
          'Build processes, templates, and guidelines that elevate the creative team\'s output.',
          'Communicate clearly, elegantly, and effectively with clients and the team.',
          'Experience in motion and 3D valued.'
        ]
      },
      responsibilities: {
        title: 'RESPONSIBILITIES',
        items: [
          'Develop concepts and visual executions for branding, digital, packaging, and multimedia content.',
          'Create prototypes, wireframes, and responsive design systems that translate brand identity into consistent digital experiences.',
          'Collaborate with internal and external teams, ensuring quality and creative cohesion.',
          'Ensure deadlines, budgets, and visual quality standards are met.',
          'Support and mentor junior and mid-level designers, providing constructive feedback and promoting high standards of craft.',
          'Participate in presentations, proposals, and creative workshops.',
          'Monitor design and experience metrics, translating insights into practical improvements.'
        ]
      },
      qualifications: {
        title: 'QUALIFICATIONS',
        items: [
          'Strong experience in multidisciplinary design, preferably in an agency or studio setting.',
          'Robust portfolio demonstrating problem-solving, innovation, and visual storytelling.',
          'Knowledge of UX/UI and design principles across multiple mediums.',
          'Strategic, autonomous, and strong sense of ownership.',
          'Comfortable with digital design, prototyping, and project management tools (Adobe Creative Suite, Figma, Notion/Monday/Asana, etc.).',
          'Fluent in English.',
          'Collaborative, proactive, detail-oriented, and able to communicate ideas clearly while inspiring confidence in clients and the team.'
        ]
      },
      whatWeOffer: {
        title: 'WHAT WE OFFER',
        items: [
          'Integration into the Founding Team of a boutique agency with global ambition.',
          'Real autonomy and direct contact with leadership, with a clear growth path.',
          'Remote work in 2025, with an office in Lisbon starting in 2026.',
          'Culture of craft, strategic creativity, and a "get things done" mindset.',
          'Competitive compensation, tailored to experience and performance growth.',
          'FAZ values diversity and believes that an inclusive environment strengthens creativity and work quality.'
        ]
      },
      locationArrangement: {
        title: 'LOCATION & ARRANGEMENT',
        items: [
          'Remote (Portugal), with occasional availability for in-person meetings or travel.',
          'Schedule compatible with international clients.'
        ]
      },
      first90Days: {
        title: 'FIRST 90 DAYS — WHAT WE EXPECT TO SEE',
        items: [
          'Completed onboarding and foundational design processes set up (templates, guidelines, dashboards).',
          '2–3 active projects with high quality, controlled deadlines, and positive client feedback.',
          'Design playbook and responsibility matrix established.'
        ]
      },
      howToApply: {
        title: 'HOW TO APPLY',
        text: 'Send CV and portfolio (PDF) to',
        email: 'hello@wearefaz.com',
        subject: 'with the subject: "Senior Multidisciplinary Designer — FAZ".'
      }
    },
    personalAssistant: {
      title: 'PERSONAL ASSISTANT / JUNIOR CHIEF OF STAFF',
      fullTime: '(FULL-TIME)',
      location: 'LISBOA',
      introduction: [
        'We are looking for a highly organized, proactive, and problem-solving Personal Assistant to join our team.',
        'This role is a hybrid between personal and professional assistant, acting as the right hand of the CEOs, ensuring both personal and professional life flow efficiently and in a structured way.'
      ],
      whatWeExpect: {
        title: 'WHAT WE EXPECT FROM A PERSONAL ASSISTANT / JUNIOR CHIEF OF STAFF',
        items: [
          'Provide direct support to the CEOs in personal and professional tasks.',
          'Manage calendars, schedule meetings, trips, and personal commitments.',
          'Organize priorities, track projects, and ensure follow-ups ("next steps") with teams.',
          'Prepare documents, presentations, and conduct small market research.',
          'Communicate with internal teams and external partners, facilitating task execution.',
          'Support day-to-day tasks, from personal organization to small management duties.',
          'Serve as a liaison between the CEOs and different stakeholders, ensuring clarity and alignment.'
        ]
      },
      qualifications: {
        title: 'QUALIFICATIONS',
        items: [
          'Strong organizational skills, attention to detail, and methodical approach.',
          'Proactive, autonomous, and able to anticipate needs.',
          'Excellent oral and written communication in Portuguese and English.',
          'Ability to handle multiple tasks simultaneously and prioritize effectively.',
          'Discretion, professionalism, and confident demeanor.',
          'Previous experience as a Personal Assistant, Executive Assistant, or similar roles (valued, but not mandatory).'
        ]
      },
      whatWeOffer: {
        title: 'WHAT WE OFFER',
        items: [
          'Integration into a dynamic and creative team.',
          'Opportunity for growth and continuous learning, with exposure to different areas of business.',
          'Close work with leadership in a strategic and trusted role.'
        ]
      },
      locationArrangement: {
        title: 'LOCATION & ARRANGEMENT',
        items: [
          'Hybrid (Lisbon), with flexibility for remote and on-site work as needed.'
        ]
      },
      howToApply: {
        title: 'HOW TO APPLY',
        text: 'Send your CV to',
        email: 'hello@wearefaz.com',
        subject: 'with the subject: "Personal Assistant / Junior Chief of Staff — FAZ".'
      }
    }
  }
}

export default enUS 